import React, { useEffect, useState } from "react";
import {
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  deleteFabricante,
  // getFabricanteById,
  getFabricantes,
} from "../../../api/fabricanteApi";
import Tabela from "../../../components/Tabela";
import { buscaFabricante } from "../../../types/fabicante";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Fabricante: React.FC = () => {
  const [fabricantes, setFabricantes] = useState<buscaFabricante[]>([]);
  // const [fabricanteSelecionada, setFabricanteSelecionada] =
  //   useState<buscaFabricante | null>(null);
  // const [modalAberta, setModalAberta] = useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFabricantes = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const fabricantesData = await getFabricantes(token);
        setFabricantes(fabricantesData);
      } catch (error) {
        toast.error("Erro ao buscar fabricantes!");
        console.error("Erro ao buscar fabricantes:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFabricantes();
  }, []);

  const handleAddFabricante = () => {
    navigate("/adicionarFabricante");
  };

  // const handleEditFabricante = (id: string) => {
  //   navigate(`/editarFabricante/${id}`);
  // };

  const handleDeleteFabricante = async (id: string) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }
      await deleteFabricante(token, id);
      setFabricantes(
        fabricantes.filter((fabricante) => fabricante.id !== Number(id))
      );
      toast.success("Fabricante excluído com sucesso!");
    } catch (error) {
      toast.error("Erro ao excluir Fabricante!");
      console.error("Erro ao excluir Fabricante:", error);
    }
  };

  // const handleViewFabricante = async (id: string) => {
  //   try {
  //     const token = localStorage.getItem("token");
  //     if (!token) {
  //       throw new Error("Token não encontrado");
  //     }
  //     const ferramentaData = await getFabricanteById(token, id);
  //     setFabricanteSelecionada(ferramentaData);
  //     setModalAberta(true);
  //   } catch (error) {
  //     toast.error("Erro ao carregar detalhes da ferramenta!");
  //     console.error("Erro ao carregar detalhes da ferramenta:", error);
  //     throw error;
  //   }
  // };

  // const handleFecharModal = () => {
  //   setModalAberta(false);
  // };

  const colunas = [
    { id: "id", label: "ID" },
    { id: "descricao_fabricante", label: "Descrição do Fabricante" },
    { id: "modelos", label: "Modelos" },
  ];

  const formatarDados = (fabricantes: buscaFabricante[]) => {
    return fabricantes.map((fabricante) => ({
      id: fabricante.id,
      descricao_fabricante: fabricante.descricao_fabricante,
      modelos: fabricante.modelos
        .map((modelo) => modelo.descricao_modelo)
        .join(", "),
    }));
  };

  return (
    <Box sx={{ p: 3 }}>
      <Tabela
        titulo="Fabricantes"
        colunas={colunas}
        dados={formatarDados(fabricantes)}
        onAdd={handleAddFabricante}
        // onEdit={handleEditFabricante}
        onDelete={handleDeleteFabricante}
        loading={loading}
        showVisibilityIcon={false}
        onView={() => {}}
      />
    </Box>
  );
};

export default Fabricante;
